import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-field-floating reactive active my-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-red"
}
const _hoisted_3 = { class: "my-4" }
const _hoisted_4 = {
  key: 1,
  class: "text-red"
}

import { ref, reactive, onMounted } from 'vue';
    import axios from 'axios';
    // @ts-expect-error raison: lib externe mal typée
    import Vue3TagsInput from 'vue3-tags-input';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketAttributsFormModal',
  props: {},
  setup(__props, { expose: __expose }) {

    // @ts-expect-error raison: lib externe mal typée
    const props = __props;
    const isModalOpen = ref(false);
    let promise: Promise<any>;
    let resolvePromise: any;
    let rejectPromise: any;
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        guid: "",
        nom: "", 
        valeurs: [],
    });
    const errors = reactive({
        nom: "",
        valeurs: "",
    });

    async function open(item?: any) {
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        if (item) {
            formData.guid = item.guid;
            formData.nom = item.nom;
            formData.valeurs = item.valeurs;
        } else {
            formData.guid = "";
            formData.nom = "";
            formData.valeurs = [];
        }
        isModalOpen.value = true;
        return await promise;
    }

    function onClose() {
        resolvePromise(null);
    }

    function onReject() {
        resolvePromise(null);
        isModalOpen.value = false;
    }

    function validate() {
        let isValid = true;

        errors.nom = '';
        if (!formData.nom) {
            errors.nom ="Le nom est requis";
            isValid = false;
        }

        errors.valeurs = '';
        if (!formData.valeurs || formData.valeurs.length === 0) {
            errors.valeurs ="Au moins une énumération est requise";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = {
                guid: formData.guid,
                nom: formData.nom,
                valeurs: formData.valeurs,
            };

            const httpResponse = await axios.post(`/backoffice/market-attributs/save`, formToUpload);
            resolvePromise(httpResponse.data);
            isModalOpen.value = false;
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }
    function handleChangeTag(newTags: any) {
        formData.valeurs = newTags;
    }

    __expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_custom_modal = _resolveComponent("custom-modal")!

  return (_openBlock(), _createBlock(_component_custom_modal, {
    show: isModalOpen.value,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((isModalOpen).value = $event)),
    onClosed: onClose
  }, {
    header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createElementVNode("div", { style: {"flex":"1","display":"flex","flex-direction":"row","justify-content":"space-between"} }, [
        _createElementVNode("h4", { class: "font-semibold" }, "Formulaire Attribut")
      ], -1)
    ]))]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        id: "btn-confirmation-confirm",
        class: "btn-ultra white2",
        style: {"justify-content":"center"},
        onClick: onSubmit
      }, "Valider"),
      _createElementVNode("button", {
        id: "btn-confirmation-reject",
        class: "btn-ultra white2",
        style: {"justify-content":"center"},
        onClick: onReject
      }, "Annuler")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.nom) = $event)),
            name: "nom",
            id: "nom",
            placeholder: "",
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, formData.nom]
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("label", { for: "nom" }, [
            _createTextVNode("Libellé "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['nom'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(errors['nom']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("label", { for: "nom" }, [
            _createTextVNode("Enumérations "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1)),
          _createVNode(_unref(Vue3TagsInput), {
            placeholder: "Saisir les énumérations",
            onOnTagsChanged: handleChangeTag,
            tags: formData.valeurs
          }, null, 8, ["tags"])
        ]),
        (!!errors['valeurs'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(errors['valeurs']), 1))
          : _createCommentVNode("", true),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "clear-both" }, null, -1))
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})